import { render, staticRenderFns } from "./PostImage.vue?vue&type=template&id=7dd527a5&scoped=true&lang=pug&"
import script from "./PostImage.vue?vue&type=script&lang=js&"
export * from "./PostImage.vue?vue&type=script&lang=js&"
import style0 from "./PostImage.vue?vue&type=style&index=0&id=7dd527a5&lang=sass&nolang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd527a5",
  null
  
)

export default component.exports